<div class="report-labels">
  <p class="text">
    By default, The Insights Application labels a student's behavior plan,
    "Behavior Intervention Plan" (BIP). The option below allows customization of
    that label. A label change will be reflected on the corresponding
    application pages as well any reports.
  </p>

  <nz-table
    #editRowTable
    [nzData]="(reportLabels$ | async) || []"
    nzTableLayout="fixed"
    [nzLoading]="loading$ | async"
    [nzScroll]="{ x: '1200', y: 'calc(100vh - 362px)' }"
    [nzShowPagination]="false">
    <thead>
      <tr>
        <th scope="col" nzWidth="300">{{ TABLE_COLUMNS[0].title }}</th>
        <th scope="col" nzWidth="300">{{ TABLE_COLUMNS[1].title }}</th>
        <th scope="col" nzWidth="150px" nzRight>
          {{ TABLE_COLUMNS[2].title }}
        </th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let data of editRowTable.data">
        <tr *ngIf="data.isVisible">
          <td [title]="data.labelKey">
            {{ data.labelKey }}
            <span class="labeleLength" *ngIf="data.length"
              >| Max length {{ data.length }}</span
            >
          </td>
          <td>
            <ng-container *ngIf="!data.isEditing; else editInput">
              <span [title]="data.overrideValue">{{ data.overrideValue }}</span>
            </ng-container>
            <ng-template #editInput>
              <div class="input-wrapper">
                <input
                  nz-input
                  [(ngModel)]="data.overrideValue"
                  (keydown.enter)="saveChanges(data)"
                  (keydown.escape)="cancelEdit(data)"
                  [maxlength]="data.length || null" />
                <div *ngIf="data.length" class="char-count">
                  {{ getCurrentLength(data) }}/{{ data.length }}
                </div>
              </div>
            </ng-template>
          </td>
          <td nzRight>
            <div class="action-btn-wrapper">
              <ng-container *ngIf="data.isEditing; else editButton">
                <button
                  nz-button
                  type="button"
                  nzType="text"
                  (click)="cancelEdit(data)">
                  Cancel
                </button>
                <button
                  nz-button
                  type="button"
                  nzType="text"
                  class="primary-text-btn"
                  (click)="saveChanges(data)">
                  Save
                </button>
              </ng-container>
              <ng-template #editButton>
                <button
                  nz-button
                  type="button"
                  nzType="text"
                  (click)="toggleEdit(data)">
                  <svg-icon
                    [title]="'Edit ' + data.labelKey"
                    src="/assets/icon/icon-edit.svg"
                    class="icon s-20"
                    aria-label="Edit"></svg-icon>
                </button>
              </ng-template>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </nz-table>
</div>
